import { PurchaseOption } from '@/features/games/shared/types/game-data';
import type { CartProductItem } from '@/features/cart/shared/types/cart.types';

export const isAlreadyInCart = (items: CartProductItem[], option: PurchaseOption) =>
  items.some(
    (item) =>
      item.productEntityId === option.productEntityId &&
      item.optionEntityId === option.optionEntityId &&
      item.optionValueEntityId === option.optionValueEntityId,
  );
